import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface AccountsReceivableResponse {
  totalAccountReceivable: number;
}

export interface GetAccountsReceivableParams {
  sessionId: string;
}

export const getAccountsReceivableAPI = async (
  params: GetAccountsReceivableParams,
) => {
  const response = await baseAPI.get<AccountsReceivableResponse>(
    '/dashboard/metrics/account-receivable/total',
    {
      params,
    },
  );
  return response.data;
};

export const useGetAccountsReceivable = (
  params: GetAccountsReceivableParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.ACCOUNTS_RECEIVABLE, params.sessionId],
    queryFn: () => getAccountsReceivableAPI(params),
    enabled: !!params.sessionId,
  });
};
